<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm lớp bán trú mới
        <v-spacer />
        <v-btn icon dark @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Tên lớp bán trú"
                placeholder="Nhập tên lớp bán trú"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="status"
                :items="[
                  { title: 'Đang hoạt động', status: 'active' },
                  { title: 'Đã ngưng', status: 'inactive' },
                ]"
                clear-icon="mdi-close"
                item-text="title"
                item-value="status"
                label="Chọn tình trạng"
                hide-details="auto"
                outlined
                dense
                clearable
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="notes" label="Mô tả chi tiết" hide-details="auto" outlined></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="closeDialog">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper.js'

export default {
  data() {
    return {
      dialog: false,
      notes: '',
      name: '',
      status: '',
      teacher: '',
      maxStudent: '',
    }
  },
  methods: {
    ...mapActions('boardingClass', ['create', 'search']),
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },

    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      await this.create({
        name: textHelpers.removeSpaces(this.name),
        notes: this.notes,
        status: this.status,
      })
      this.reset()
      this.$refs.form.resetValidation()
      await this.refresh()
      this.dialog = false
      this.$loading.active = false
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async refresh(query) {
      query = query || {}
      await this.search({
        ...query,
      })
    },
  },
}
</script>
